import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Logo from '../components/Logo';
import { getApiUrl } from '../config/api.config';

const ForgotPassword = () => {
	const [email, setEmail] = useState('');
	const [status, setStatus] = useState('idle'); // 'idle' | 'loading' | 'success' | 'error'
	const [message, setMessage] = useState('');
	const [error, setError] = useState('');

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError('');
		setMessage('');
		setStatus('loading');

		try {
			await axios.post(getApiUrl('auth/forgot-password'), { email });
			setStatus('success');
			setMessage('If an account exists with that email, you will receive a password reset link shortly. Please check your inbox and spam folder.');
		} catch (err) {
			setStatus('error');
			setError(
				err.response?.data?.message ||
					err.response?.data?.error ||
					err.message ||
					'Something went wrong. Please try again.'
			);
		}
	};

	return (
		<div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 py-12 px-4 sm:px-6 lg:px-8">
			<div className="max-w-md w-full">
				<div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
					<div className="px-10 py-12">
						<div className="text-center mb-8">
							<div className="flex justify-center items-center mb-6">
								<Logo showText={true} width={80} height={80} className="justify-center" />
							</div>
							<h2 className="text-2xl font-bold text-gray-900 mb-2">Forgot password</h2>
							<p className="text-gray-600 text-sm">
								Enter your email and we&apos;ll send you a link to reset your password.
							</p>
						</div>

						<form className="space-y-6" onSubmit={handleSubmit}>
							{error && (
								<div className="bg-red-50 border border-red-200 rounded-lg p-4">
									<div className="flex items-center">
										<svg className="w-5 h-5 text-red-400 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
											<path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
										</svg>
										<span className="text-sm text-red-800">{error}</span>
									</div>
								</div>
							)}

							{status === 'success' && (
								<div className="bg-green-50 border border-green-200 rounded-lg p-4">
									<div className="flex items-start">
										<svg className="w-5 h-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
											<path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
										</svg>
										<span className="text-sm text-green-800">{message}</span>
									</div>
								</div>
							)}

							{status !== 'success' && (
								<>
									<div>
										<label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
											Email address
										</label>
										<input
											id="email"
											name="email"
											type="email"
											required
											value={email}
											onChange={(e) => setEmail(e.target.value)}
											className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200 text-gray-900 placeholder-gray-400"
											placeholder="Enter your email"
										/>
									</div>
									<button
										type="submit"
										disabled={status === 'loading'}
										className="w-full py-3 px-4 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-semibold rounded-lg shadow-lg transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
									>
										{status === 'loading' ? (
											<span className="flex items-center justify-center">
												<svg className="animate-spin -ml-1 mr-2 h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
													<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
													<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
												</svg>
												Sending...
											</span>
										) : (
											'Send reset link'
										)}
									</button>
								</>
							)}

							<div className="text-center">
								<Link to="/login" className="text-sm font-medium text-blue-600 hover:text-blue-500">
									Back to sign in
								</Link>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ForgotPassword;
